import styles from './IconButton.scss';

import cx from 'classnames';
import React, { forwardRef } from 'react';

import { Icon, IconProps } from 'src/components/Icon/Icon';

export interface IconButtonProps extends Pick<IconProps, 'type' | 'title'>, React.HTMLAttributes<HTMLButtonElement> {
  iconProps?: Omit<IconProps, 'type' | 'title'>;
  children?: never;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(({
  className,
  type,
  title,
  iconProps,
  ...props
}, ref) => {
  if (!type) return null;
  return (
    <button ref={ref} data-test="icon-button" className={cx(styles.iconButton, type, className)} {...props}>
      <Icon {...{ title, type }} {...iconProps} />
    </button >
  );
});
